import Cookies from 'js-cookie';

export function setSnapchatCookies(searchParams: URLSearchParams) {
  const ScCid = searchParams.get('ScCid');

  if (ScCid) {
    Cookies.set('ScCid', ScCid);
  }
}
